import { Link } from "../Link.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export function Thumbnail(_ref) {
  var {
    newTab,
    href,
    src,
    width,
    height
  } = _ref;
  return /*#__PURE__*/_jsx(Link, {
    href: href,
    className: 'prezly-slate-bookmark-card-component__thumbnail',
    style: {
      backgroundImage: "url(\"".concat(src, "\")")
    },
    newTab: newTab,
    children: /*#__PURE__*/_jsx("img", {
      className: 'prezly-slate-bookmark-card-component__thumbnailImage',
      src: src,
      width: width,
      height: height,
      alt: "Website preview"
    })
  });
}